import { Dimensions } from "react-native";

const { width: screenW, height: screenH } = Dimensions.get("window");

const size = {
  screenW,
  screenH,

  tapOpacity: 0.6,

  space: 12,

  drawerW: 230,

  radius: {
    xs: 9,
    sm: 12,
    md: 15,
    lg: 15,
  },

  drawerWidth: screenW * 0.75,
};

export default size;
